<template lang="pug">
  .change-record-container(v-if="show")
    .shadow(@click="closeModal")
    .change-record
      .no-use-top
        img.no-use-close(src="https://m.hellobike.com/resource/gallery/61/__G7W1L7To.png?x-oss-process=image/quality,q_80" @click="closeModal")
      .change-record-title 置换不用的券
      .change-record-word
        span 以下券支持更换（每张券仅限1次）
      .ride-card(v-if="exlist.length>0")
        CouponOpenedLotteryNew.coupon-item(v-for="(item,index) in exlist"
          :item="item" @click-btn="firstStatus"
          :couponGameAB="couponGameAB"
          :isChangeIt="isChangeIt(item)"
          @changeIt="changeIt"
          )
      .ride-no-card(v-else)
        .no-img
          img(src="https://m.hellobike.com/resource/gallery/61/BxqbUTMW4e.png?x-oss-process=image/quality,q_80")
        .no-word 暂无变更记录
    </template>
<script>
import CouponOpenedLotteryNew from '@/pages/vip/super/components/coupon-opened-lottery-new.vue';

export default {
  components: {
    CouponOpenedLotteryNew,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    groups: {
      type: Array,
      default: () => [],
    },
    couponGameAB: {
      type: String,
      default: 'N',
    },
  },
  data() {
    return {
    };
  },
  computed: {
    exlist() {
      if (Array.isArray(this.groups)) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        return this.groups.filter((x) => (x.status === 1
          && (x.afterVipReplacementProperty))
          || x.status === 9);
      }
      return [];
    },
  },
  watch: {
    groups(val) {
      this.list = val;
    },
  },
  destroyed() {
  },
  created() {
  },
  mounted() {
  },
  methods: {
    isChangeIt(item) {
      if ((item.status === 1)
        && (item.afterVipReplacementProperty || item.afterVipRecycleProperty)) {
        return 1; // 弹窗页有换掉Ta样式
      }
      return 2; // 弹窗页普通样式
    },
    changeIt(val, item) {
      this.$emit('changeIt', val, item);
    },
    closeModal() {
      this.$emit('update:show', false);
    },
    firstStatus(val) {
      this.$emit('click-btn', val);
    },
  },
};
</script>
<style lang="less" scoped>

.change-record-container {
  position: fixed;
  bottom: 0;
  z-index: 222;
  width: 100%;

  .change-record {
    background: linear-gradient(180deg, #fce38a 0%, #fff 5.56%);
    box-shadow: 0 0.01rem 0.05rem 0 rgba(255, 255, 255, 0.27);
    border-radius: 0.05rem 0.05rem 0 0;
    position: relative;
    z-index: 223;
    height: 4.04rem;
    padding-top: 0.19rem;

    .no-use-top {
      img.no-use-close {
        position: absolute;
        top: 0.087rem;
        right: 0.067rem;
        height: 0.23rem;
        width: 0.23rem;
      }
    }

    .change-record-title {
      font-family: PingFangSC-Regular, PingFang SC, sans-serif;
      font-size: 0.16rem;
      font-weight: 600;
      line-height: 0.22rem;
      text-align: center;
      color: #6f2500;
    }

    .change-record-word {
      text-align: center;
      margin-top: 0.04rem;
      font-family: PingFangSC-Regular, PingFang SC, sans-serif;
      font-size: 0.14rem;
      font-weight: 500;
      line-height: 0.22rem;
      color: #5a6066;

      span.brown-word {
        color: #d49069;
      }
    }

    .ride-card {
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      flex: 1;
      margin-top: 0.2rem;
      padding: 0 0 0 0.2rem;
      .coupon-item {
        /* margin-right: 0.06rem; */
        background-size: 100% 100%;
        margin-bottom: 0.1rem;
        margin-right: 0.08rem;
      }
    }

    .ride-no-card {
      margin-top: 0.2rem;
      padding: 0 0.27rem 0 0.25rem;

      .no-img {
        margin: 0.53rem auto 0 auto;
        display: flex;
        justify-content: center;

        img {
          margin: 0 auto;
          width: 1.6rem;
          height: 1.25rem;
        }
      }

      .no-word {
        margin-top: 0.16rem;
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
        ;
        font-size: 0.16rem;
        font-weight: 400;
        line-height: 0.224rem;
        text-align: center;

      }
    }
  }

  .shadow {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: #000;
    opacity: 0.7;
    z-index: 100;
  }
}
</style>
